import { Stack } from '@mui/material'
import { pick } from 'ramda'
import { useParams } from 'react-router-dom'

import { HistoricList, PublishDialog } from '@/components'
import { useComponentProvider } from '@/components/ViewComponentModal/ViewComponentProvider'
import { useListHistory } from '@/hooks'
import {
  useGetCustomComponent,
  useUpdateCustomComponent,
} from '@/screens/ComponentLibrary/hooks'
import {
  CustomComponentEnhanced,
  storeKey,
} from '@/screens/ComponentLibrary/hooks/CONSTANTS'

import { parseInlineSignupData } from './ConfigData'
import { InlineSignupSettings } from './Settings'

interface InlineSingupComponent
  extends CustomComponentEnhanced<InlineSignupSettings> {}

export const History = () => {
  const { orgID } = useParams<{
    orgID: string
  }>()
  const { componentID } = useComponentProvider()

  const queryKey = [storeKey, componentID, 'history']

  const updateSemanticSearch =
    useUpdateCustomComponent<InlineSignupSettings>(componentID)
  const currentSemanticSearch =
    useGetCustomComponent<InlineSignupSettings>(componentID)
  const historyQuery = useListHistory(
    queryKey,
    'customComponent',
    { id: componentID },
    parseInlineSignupData
  )
  const parseData = (
    data?: InlineSingupComponent | null
  ): InlineSingupComponent => {
    if (!data) return {} as InlineSingupComponent
    return pick(
      ['name', 'description', 'settings', 'type'],
      data
    ) as InlineSingupComponent
  }

  const restoreVersion = async (data: Record<string, unknown>) => {
    const restoredData = parseData(data as unknown as InlineSingupComponent)
    if (!restoredData) return
    await updateSemanticSearch.mutateAsync(restoredData)
  }

  return (
    <Stack height="70vh">
      <HistoricList data={historyQuery.data} restore={restoreVersion} />
      <PublishDialog
        dataToSave={parseData(currentSemanticSearch.data)}
        extraInfo={{
          customComponentHistoryId: componentID,
          organizationHistoryId: orgID,
        }}
        queryKey={queryKey}
      />
    </Stack>
  )
}
